import React from "react";
import { ToolTipWrapper } from "../../../layout/ToolTipWrapper/ToolTipWrapper";
import IconComponent from "../../../shared/IconComponents/IconComponent";
import { Loader } from "../../../shared/Loader/Loader";
import { useAppSelector } from "../../../../redux/hooks";
import { rootState } from "../../../../redux/store";

interface IProjectPathIconProps {
    hasProjectPath: boolean;
}

export const ProjectPathIcon: React.FC<IProjectPathIconProps> = ({hasProjectPath}) => {
    const {userSettingsProjectPathLoading} = useAppSelector((state: rootState) => state.userSettingsProjectPath);
    
    return (
        <>
            {
                userSettingsProjectPathLoading
                ?
                <Loader hasText={false} height={16} width={16} color='accent-green'/>
                :
                hasProjectPath 
                &&
                <ToolTipWrapper
                    toolTipContent={{
                        title: "Project path",
                        toolTip: [
                            { label: 'Warning', value: 'Project path not defined'},
                        ],
                        color: 'white',
                        iconName: 'Project_path_not_set',
                        iconSize: 2.5,
                        fixedSize: true,
                    }}
                >
                    <IconComponent size={2.4} iconName={'Project_path_not_set'}/>
                </ToolTipWrapper>
            }
        </>
    )

}